export default {
  userProfile: {
    header: {
      title: "Impostazioni profilo",
      subtitle: "Gestisci il tuo profilo Linemate",
    },
    sections: {
      accountDetails: "Dettagli account",
      billing: "Fatturazione",
    },
    labels: {
      oldPassword: "Vecchia password",
      newPassword: "Nuova password",
      confirmNewPassword: "Conferma nuova password",
      enterYourPassword: "Inserisci la password",
      showAll: "Mostra tutto",
    },
    descriptions: {
      changePassword: "Cambia la password del tuo account Linemate",
      preferredOdds: "Scegli le quote preferite per trend e Le mie scelte",
      language: "Seleziona la lingua in cui vuoi visualizzare Linemate.",
      odds: "Seleziona il formato in cui vuoi visualizzare le quote.",
      theme: "Seleziona come viene visualizzato Linemate.",
      billingPrimary: "Tieni traccia del tuo piano e delle opzioni di pagamento",
      billingSecondary: "Linemate collabora con Stripe per semplificare fatturazione e gestione dei pagamenti.",
      deleteAccount: "Elimina account e dati dell'account",
      deleteAccountSecondary: "Se vuoi eliminare definitivamente il tuo account, puoi farlo a destra.",
    },
    actions: {
      update: "Aggiorna",
      choosePreferredOdds: "Scegli le quote preferite",
      saveMyChoices: "Salva le mie scelte",
      manageBilling: "Gestisci fatturazione",
      deleteThisAccount: "Elimina questo account",
    },
    deleteAccount: {
      confirmMessage: "Vuoi davvero eliminare il tuo account? Se sì, continua qui sotto.",
      permanentWarning: "Ricorda che tutti i tuoi dati saranno rimossi definitivamente dai nostri server. Questa azione terminerà il tuo abbonamento per il prossimo periodo di fatturazione e non può essere annullata.",
      acknowledgment: "Riconosco che tutti i dati in questo account saranno eliminati e voglio continuare.",
    },
    validation: {
      passwordRequirements: "La password deve includere una lettera maiuscola, una lettera minuscola e almeno 8 caratteri.",
      confirmPasswordMismatch: "La conferma password non corrisponde.",
      incorrectPassword: "Password errata.",
    },
  },
};
